import { FC } from 'react';
import { twMerge } from '@utils/twMerge';
import { CheckIcon, CloseIcon } from '@dynamika-shared/ui/icons';
import { Divider } from 'antd';
import { OHIFImagingLabel } from '@dynamika-shared/types/imagingLabels';
import { format, parseISO, isValid } from 'date-fns';
import { normalizeLabelText } from './qcLabels.helpers';

type LabelItemProps = {
  label: OHIFImagingLabel;
  selected?: boolean;
};

export const LabelItem: FC<LabelItemProps> = ({ label, selected }) => {
  const assigned =
    label?.assignedToSeriesId || label?.assignedToSeriesInstanceUId || selected;
  const textClass = twMerge(
    'text-1424 font-semibold min-w-[100px]',
    assigned ? 'text-yellowGreen' : 'text-spanishGray'
  );
  const iconClass = assigned
    ? ''
    : 'rounded-full bg-pastelBlue [&>path]:stroke-white';

  const formatDate = (dateString?: string | null): string => {
    if (!dateString) return '';
    try {
      const date = parseISO(dateString);
      return isValid(date) ? format(date, 'dd-MMM-yyyy') : dateString;
    } catch {
      return dateString;
    }
  };

  const Icon = assigned ? CheckIcon : CloseIcon;
  return (
    <div className='mx-[10px]' key={label?.id}>
      <div className='flex items-center justify-between gap-2'>
        <div className='flex gap-1 text-1624 font-normal grow'>
          <div className={'w-2 h-2 mt-[4px]'}><Icon className={iconClass} /></div>
          {normalizeLabelText(label?.name)}
        </div>
        <div className={'min-w-[90px] whitespace-nowrap'}>{formatDate(label.acquisitionDate)}</div>
        <div className={textClass}>
          {assigned ? 'Assigned' : 'Not Assigned'}
        </div>
      </div>
      <Divider />
    </div>
  );
};
